import { User } from '@vis-auth/vis-user-client';

export const initializeUserData = async (userId: string, token: string): Promise<User> => {
  const headers = new Headers();
  headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(`/api/visuser/users/${userId}`, { headers: headers });
  const data = await response.json();
  setUserData(data);
  return data;
};

let userData: User;

export const getUserData = (): User => userData;

const setUserData = (data: User): void => {
  userData = data;
};
